<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[90%] xl:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] md:px-[30px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            View Campaign: {{ campaignName }}
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
      </div>
      <div
        class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
      >
        <div class="flex justify-between items-center mb-[16px]">
          <h2
            class="text-[20px] leading-[28px] text-[#353535] font-semibold mb-[24px]"
          >
            {{ campaignName }} Members
          </h2>
          <div class="">
            <button
              class="bg-[#2463EB] text-white text-[14px] leading-[20px] border-[#2463EB] border-solid rounded-[8px] outline-none focus:outline-none py-[8px] px-[10px]"
              @click="viewAdd"
            >
              <span class="mdi mdi-plus"></span>
              Add Members
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table dataTable text-nowrap">
            <thead class="bg-white">
              <tr>
                <th>Name</th>
                <th>Member Type</th>
                <th>Joined</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="m in members" :key="m.id">
                <td>{{ m.memberName }}</td>
                <td>{{ m.type }}</td>
                <td>{{ formatDate(m.joined) }}</td>
                <td>
                  <span
                    class="text-[14px] font-normal leading-[20px] text-[#DC2828]"
                    @click.prevent="remove(m.id)"
                  >
                    Remove
                  </span>
                </td>
              </tr>
              <tr v-if="!members.length">
                <td colspan="4">
                  <div class="text-center">No members</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <add-new-member
      @onMemberAddComplete="onMemberAddCompleteHandler"
      :campaignId="campaignId"
    />
  </div>
</template>

<script>
import moment from "moment";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import AddNewMember from "./AddNewMember.vue";
export default {
  props: ["closeModal", "campaignId"],
  mixins: [SystemPermissions.Mixin],
  name: "campaignsMembers",

  components: {
    Select2,
    AddNewMember,
  },

  created() {
    if (!this.hasPermission("Campaign_View_Members")) {
      this.$router.push("/restricted");
    }
    this.getCampaign();
    this.getMembers();
  },

  data() {
    return {
      campaignName: "",
      isBusy: false,
      isBusyModal: false,
      members: [],
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  methods: {
    viewAdd() {
      $("#mod-add").modal("show");
    },

    remove(id) {
      this.isBusy = true;

      this.$http
        .delete("/Campaigns/deleteMember/" + id)
        .then(function(res) {
          this.isBusy = false;
          this.getMembers();
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    getCampaign() {
      this.isBusy = true;
      this.$http
        .get("/Campaigns/getById/" + this.campaignId)
        .then(function(res) {
          this.campaignName = res.body.name;
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    getMembers() {
      this.isBusy = true;

      this.$http
        .get("/Campaigns/getMembers/" + this.campaignId)
        .then(function(res) {
          this.members = res.body;
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    onMemberAddCompleteHandler() {
      $("#mod-add").modal("hide");
      this.getMembers();
    },

    formatDate(date) {
      return moment(date).format("ll");
    },
  },
};
</script>

<style></style>
